import { documentReady, throttle, index, isHidden } from "../Utility/utils";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let isTimelinePresent = false;
const body = document.querySelector('body');

function init_timeline() {
  const timeline = document.querySelector(".timeline");

  if (!!timeline) {
    const timelineTrack = timeline.querySelector(".timeline__track");
    let registeredScroll = false;
    let outerWidth = timelineTrack.offsetWidth;
    let innerWidth = timelineTrack.querySelector(".timeline__track_inner").scrollWidth;
    let toX = 0;

    timeline.style.setProperty("--timeline-width", innerWidth + 'px');

    const isScrollable = () => {
      const isScrollable = !timeline.classList.contains('lock-scroll');
      return isScrollable;
    }

    const updatePct = () => {
      const pct = (timelineTrack.scrollLeft / (innerWidth - outerWidth)) * 100;

      timelineTrack.dataset.scrollPercent = pct;
      timeline.style.setProperty("--scroll-pct", `${timelineTrack.dataset.scrollPercent}%`);
    };
    updatePct();

    const updateScroll = (val) => {
      if(!isNaN(val)){
        timelineTrack.setAttribute("data-scroll", val);
        toX = val;
      }
    };

    window.addEventListener(
      "resize",
      throttle((e) => {
        let outerWidth = timelineTrack.offsetWidth;
        let innerWidth = timelineTrack.querySelector(".timeline__track_inner").scrollWidth;
        timeline.style.setProperty("--timeline-width", innerWidth + 'px');
      }, 10)
    );

    // Make scrollwheel / trackpad scroll horizontally.
    timelineTrack.addEventListener("scroll", (evt) => {
      if(isScrollable()){
        if (!registeredScroll) {
          updateScroll(timelineTrack.scrollLeft + evt.deltaY + evt.deltaX);
        }
      }
    });

    timelineTrack.addEventListener(
      "wheel",
      throttle((evt) => {
        if(isScrollable()){
          registeredScroll = true;
          evt.preventDefault();
          const tpMultiplier = evt.deltaY % 1 === 0 ? 6 : 2;

          const direction = evt.deltaY + evt.deltaX < 0 ? -1 : 1;
          const minInc = 200 * direction;
          const maxInc = 2000 * direction;
          let finalInc = 0;

          if (direction === -1) {
            finalInc = Math.min(minInc, Math.max(maxInc, evt.deltaY * tpMultiplier + evt.deltaX * tpMultiplier));
          } else {
            finalInc = Math.max(minInc, Math.min(maxInc, evt.deltaY * tpMultiplier + evt.deltaX * tpMultiplier));
          }

          // console.log(finalInc);

          updateScroll(timelineTrack.scrollLeft + finalInc);
        }
      }, 10)
    );


    // Back to Start
    const backBtn = document.querySelector('.timeline__back');
    if(!!backBtn){
      backBtn.addEventListener('click', function(e){
        registeredScroll = true;
        updateScroll(0);
      });
    }

    // Allow for dragging
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    window.addEventListener("keydown", (e) => {
      if(isScrollable()){
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
          registeredScroll = true;
          updateScroll(timelineTrack.scrollLeft - 100);
        } else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
          registeredScroll = true;
          updateScroll(timelineTrack.scrollLeft + 100);
        }
      }
    });

    const mouseDownHandler = function (e) {
      if(isScrollable()){
        registeredScroll = true;

        // Change the cursor and prevent user from selecting the text
        timelineTrack.style.cursor = "grabbing";
        timelineTrack.style.userSelect = "none";

        pos = {
          left: timelineTrack.scrollLeft,
          x: e.clientX ?? e.touches?.[0]?.clientX + e.touches?.[0]?.clientY ?? 0,
        };

        document.addEventListener("mousemove", mouseMoveHandler);
        document.addEventListener("mouseup", mouseUpHandler);
      }
    };

    const mouseMoveHandler = function (e) {
      registeredScroll = true;

      const cx = e.clientX ?? e.touches?.[0]?.clientX + e.touches?.[0]?.clientY ?? 0;
      const dx = cx - pos.x;
      updateScroll(pos.left - dx);
    };

    const mouseUpHandler = function () {
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);

      timelineTrack.style.cursor = "grab";
      timelineTrack.style.removeProperty("user-select");
    };

    // Attach the handler
    timelineTrack.addEventListener("mousedown", mouseDownHandler);

    const update = () => {
      if (registeredScroll) {
        const dx = toX - timelineTrack.scrollLeft;

        if (dx > 1 || dx < -1) {
          timelineTrack.scrollLeft += dx * 0.1;
        } else {
          timelineTrack.scrollLeft = toX;
          registeredScroll = false;
        }
      }
      updatePct();
      requestAnimationFrame(update);
    };

    requestAnimationFrame(update);

    if (window.safari) {
      history.pushState(null, null, location.href);
      window.onpopstate = function(event) {
          history.go(1);
      };
    }

    // Clear tooltip
    const tooltip = timeline.querySelector('.timeline__tooltip');
    if(!!tooltip){
      tooltip.addEventListener('click', function(){
        timeline.classList.remove('tooltip-visible');
        document.documentElement.classList.remove('tooltip-visible');
        timeline.classList.remove('lock-scroll');
        tooltip.setAttribute('aria-hidden', 'true');
      });
    }

    // Add click event to timeline progress bar
    const progressBar = timeline.querySelector('.timeline__progress_bar');
    progressBar.addEventListener('click', (e) => {
      let targetPos;

      if(!timeline.classList.contains('tooltip-seen') && !sessionStorage.getItem("timeline_tooltip_seen")){
        targetPos = outerWidth;
      }
      else {
        const clickXPos = e.offsetX;
        const elWidth = progressBar.offsetWidth;
        const percent = clickXPos / elWidth;
        targetPos = percent * (innerWidth - outerWidth);
      }

      registeredScroll = true;
      updateScroll(targetPos);
    });

    // Animate in individual dates and update case tracker
    const dates = timeline.querySelectorAll(".timeline__dates__date");
    if (dates) {
      // Change the size of each line as we loop through.
      const lineSizes = ["small", "medium", "large", "x-large"];
      let lineSizeDirection = "up";
      let lineSizeCurrent = 1;
      let i = 1;

      const caseTracker = timeline.querySelector('.timeline__case_tracker .cases .value');
      const activeMonthEl = timeline.querySelector('.timeline__case_tracker .date .month');
      const activeYearEl = timeline.querySelector('.timeline__case_tracker .date .year');

      dates.forEach((date) => {
        // Add class for line size
        date.classList.add(lineSizes[lineSizeCurrent]);
        const month = date.getAttribute('data-month');
        const year = date.getAttribute('data-year');
        const cases = date.getAttribute('data-case-count');
        const isFirstDate = date == dates[0];
        const isLastDate = date == dates[dates.length - 1];

        // Change line size on every second item
        if (i % 2 == 0) {
          if (lineSizeDirection == "up") {
            if (lineSizeCurrent == lineSizes.length - 1) {
              lineSizeDirection = "down";
              lineSizeCurrent--;
            } else {
              lineSizeCurrent++;
            }
          } else {
            if (lineSizeCurrent == 0) {
              lineSizeDirection = "up";
              lineSizeCurrent++;
            } else {
              lineSizeCurrent--;
            }
          }
        }
        i++;

        // Animate items in based on scroll
        ScrollTrigger.create({
          trigger: date,
          start: "left right-=100px",
          end: "left right-=130px",
          invalidateOnRefresh: true,
          scrub: 0.5,
          // markers: true,
          horizontal: true,
          scroller: timelineTrack,
          onEnter: function (self) {
            date.classList.add("visible");

            // On the first date, trigger the tooltip and scroll to the start of the dates section
            if(date.classList.contains('first-date') && !timeline.classList.contains('tooltip-seen') && !sessionStorage.getItem("timeline_tooltip_seen")){
              timeline.classList.add('tooltip-seen');
              timeline.classList.add('lock-scroll');

              const hero = timeline.querySelector('.timeline__hero');
              const datesLeft = hero.offsetWidth + 90;

              // Give the date a bit of time to animate in
              setTimeout(function(){
                timeline.classList.add('tooltip-visible');
                document.documentElement.classList.add('tooltip-visible');
                tooltip.setAttribute('aria-hidden', 'false');
                updateScroll(datesLeft);
              }, 300);
            }

            if(cases){
              caseTracker.innerHTML = cases;
            }
            activeMonthEl.innerHTML = month;
            activeYearEl.innerHTML = year;

            if(isFirstDate && cases){
              timeline.querySelector('.timeline__case_tracker').classList.add('active');
            }
          },
          onEnterBack: function (self) {
            if(cases){
              caseTracker.innerHTML = cases;
            }
            activeMonthEl.innerHTML = month;
            activeYearEl.innerHTML = year;

            if(isLastDate && cases){
              timeline.querySelector('.timeline__case_tracker').classList.add('active');
            }
          },
          onLeaveBack: function (self) {
            if(isFirstDate && cases){
              timeline.querySelector('.timeline__case_tracker').classList.remove('active');
            }
          },
          onLeave: function (self) {
            if(isLastDate && cases){
              timeline.querySelector('.timeline__case_tracker').classList.remove('active');
            }
          }
        });

        // Add hover effect on child a element
        const a = date.querySelector("a");
        a.addEventListener("mouseenter", () => {
          date.classList.add("hovered");
        });
        a.addEventListener("mouseleave", () => {
          date.classList.remove("hovered");
        });
      });
    }
  }
}

documentReady((event) => {
  init_timeline();

  // Stats
  const statSection = document.querySelector(".timeline__stats");
  if (!!statSection) {
    const select = statSection.querySelector(".timeline__stats__trigger");
    const selectLabel = select.querySelector("span");
    const optionsWrap = statSection.querySelector(".timeline__stats__options");
    const options = optionsWrap.querySelectorAll("a");

    select.addEventListener("click", function (e) {
      e.preventDefault();
      select.blur();

      if (optionsWrap.classList.contains("active")) {
        select.classList.remove("active");
        optionsWrap.classList.remove("active");
        optionsWrap.setAttribute("aria-hidden", "true");
      } else {
        select.classList.add("active");
        optionsWrap.classList.add("active");
        optionsWrap.setAttribute("aria-hidden", "false");
      }
    });

    options.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        item.blur();

        // Change the text of the select trigger
        selectLabel.innerHTML = item.innerHTML;

        const targetID = item.getAttribute("data-target");
        const target = statSection.querySelector("#" + targetID);
        const activeStat = statSection.querySelector(".timeline__stats__display.active");

        // Remove active class from other lists
        if (!!activeStat && activeStat !== target) {
          activeStat.classList.remove("active");
          activeStat.setAttribute("aria-hidden", "true");
        }

        // Set target as active
        target.classList.add("active");
        target.setAttribute("aria-hidden", "false");

        // Close options list.
        select.classList.remove("active");
        optionsWrap.classList.remove("active");
        optionsWrap.setAttribute("aria-hidden", "true");
      });
    });
  }

  // Timeline Modal Nav
  const modal_nav = document.querySelectorAll('.timeline__modal_nav');
  if(modal_nav.length){
    modal_nav.forEach(item => {
      const parentModal = item.closest('.modal');
      const parentID = parentModal.getAttribute('id');
      const dates = document.querySelectorAll('.timeline__dates__date a');
      const isFirstModal = parentID == dates[0].getAttribute('modal-target');
      const isLastModal = parentID == dates[dates.length - 1].getAttribute('modal-target');

      if(isFirstModal){
        parentModal.querySelector('.prev').setAttribute('disabled', true);
      }
      if(isLastModal){
        parentModal.querySelector('.next').setAttribute('disabled', true);
      }

      item.addEventListener('click', (e) => {
        const direction = item.classList.contains('prev') ? 'prev' : 'next';
        const targetModal = direction == 'prev' ? parentModal.previousElementSibling : parentModal.nextElementSibling;

        // Close current modal
        const parentButtons = parentModal.querySelectorAll('button, a');
        parentModal.setAttribute('aria-hidden', 'true');
        parentModal.classList.remove('active');
        parentButtons.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });

        // Open target modal
        const targetButtons = targetModal.querySelectorAll('button, a');
        targetModal.setAttribute('aria-hidden', 'false');
        targetModal.classList.add('active');
        targetButtons.forEach(button => {
          button.setAttribute('tabindex', '1');

          if(button.classList.contains(direction) && !button.getAttribute('disabled')){
            button.focus();
          }
        });
      });
    });
  }
});
